import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import { Link } from "react-scroll";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import LogoIcon from "../../assets/svg/Logo";
import BurgerIcon from "../../assets/svg/BurgerIcon";

export default function TopNavbar() {
  // const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);
  let location = useLocation();

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <nav className="fixed top-0 left-0 w-full z-50 bg-white shadow">
        <div className="max-w-7xl mx-auto px-2 lg:px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          {location.pathname === '/' ?
            (<Link className="flex items-center cursor-pointer" to="home" smooth={true}>
              <LogoIcon />
            </Link>)
            :
            (<a style={{ padding: "10px 15px" }} href="/"><LogoIcon /></a>)
          }
          <button aria-label="Open menu" className="p-2 md:hidden" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </button>
          <ul className="hidden md:flex items-center gap-1">
            <li className="font-medium text-xs lg:text-sm cursor-pointer">
              {location.pathname === '/' ?
                (<Link activeClass="border-b-2 border-amber-500 text-amber-500" className="px-2 lg:px-4 py-2 hover:text-amber-500" to="home" spy={true} smooth={true} offset={-80}>Home</Link>)
                :
                (<a className="px-2 lg:px-4 py-2 hover:text-amber-500" href="/">Home</a>)
              }
            </li>
            <li className="font-medium text-xs lg:text-sm cursor-pointer">
              {location.pathname === '/' ?
                (<Link activeClass="border-b-2 border-amber-500 text-amber-500" className="px-2 lg:px-4 py-2 hover:text-amber-500" to="about-us" spy={true} smooth={true} offset={-80}>
                  Über uns
                </Link>)
                :
                (<a className="px-2 lg:px-4 py-2 hover:text-amber-500" href="/#about-us">Über uns</a>)
              }
            </li>
            <li className="font-medium text-xs lg:text-sm cursor-pointer">

              {location.pathname === '/' ?
                (<Link activeClass="border-b-2 border-amber-500 text-amber-500" className="px-2 lg:px-4 py-2 hover:text-amber-500" to="services" spy={true} smooth={true} offset={-80}>
                  Dienstleistungen
                </Link>)
                :
                (<a className="px-2 lg:px-4 py-2 hover:text-amber-500" href="/#services">Dienstleistungen</a>)
              }
            </li>
            <li className="font-medium text-xs lg:text-sm cursor-pointer">

              {location.pathname === '/' ?
                (<Link activeClass="border-b-2 border-amber-500 text-amber-500" className="px-2 lg:px-4 py-2 hover:text-amber-500" to="locations" spy={true} smooth={true} offset={-80}>
                  Einsatzorte
                </Link>)
                :
                (<a className="px-2 lg:px-4 py-2 hover:text-amber-500" href="/#locations">Einsatzorte</a>)
              }
            </li>
            <li className="font-medium text-xs lg:text-sm cursor-pointer">

              {location.pathname === '/' ?
                (<Link activeClass="border-b-2 border-amber-500 text-amber-500" className="px-2 lg:px-4 py-2 hover:text-amber-500" to="fuhrpark" spy={true} smooth={true} offset={-80}>
                  Fuhrpark
                </Link>)
                :
                (<a className="px-2 lg:px-4 py-2 hover:text-amber-500" href="/#fuhrpark">Fuhrpark</a>)
              }
            </li>
            <li className="font-medium text-xs lg:text-sm cursor-pointer">

              {location.pathname === '/' ?
                (<Link activeClass="border-b-2 border-amber-500 text-amber-500" className="px-2 lg:px-4 py-2 hover:text-amber-500" to="contact" spy={true} smooth={true} offset={-80}>
                  Kontakt
                </Link>)
                :
                (<a className="px-2 lg:px-4 py-2 hover:text-amber-500" href="/#contact">Kontakt</a>)
              }
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}



